export const white = "#fafafa";
